// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ae64b026","455":"3cfa46c6","977":"56e3a5bf"}[chunkId] + ".chunk.js";
};